__webpack_require__.p = "/kare-pkg/";